import React, { useEffect, useState } from "react";
import "./index.scss";
import Button from "../../../../components/common/button/index";
import FormModal from "./component/formModal";
import Loader from "../../../../components/common/loader";
import { api_strapi } from "../../../../utils/interface";

const OtherInsuranceCard = ({ img, desc, btn, btnLink, title, id, redirectURL }) => {
  const [show, setShow] = useState(false);
  const [modalData, setModalData] = useState({});
  const [loading, setLoader] = useState(false);
  const [fields, setFields] = useState([]);

  const handleClose = () => setShow(false);

  const handleClick = () => {
    if (redirectURL) {
      window.open(redirectURL, "_blank");
    } else {
      handleModalShow(id);
    }
  };

  const handleModalShow = (id) => {
    setLoader(true);

    const formFields = async () => {
      const response = await api_strapi.get(
        `/form-modals/${id}?populate=form.form.forminputField.forms`
      );

      if (response && response.status === 200) {
        setModalData(response?.data?.data?.attributes);
        setShow(true);
        setLoader(false);
        setFields(
          response?.data?.attributes?.form?.form?.forminputField?.forms?.map(
            (item) => item?.name
          ) || []
        );
      }
    };
    formFields();
  };

  return (
    <>
      <div className="other--insurance--card">
        <div className="insurance--card--img">
          <img src={img} className=" " alt="..." />
        </div>
        <h5 className="insurance--card--title">{title}</h5>
        <div className="insurance--card--btn">
          <>
            <Button
              type="button"
              variant="primaryBox"
              label={`${btn}`}
              onClick={() => handleClick()}
            />
          </>
        </div>
      </div>
      <FormModal
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        modalData={modalData}
        fields={fields}
      />
    </>
  );
};

export default OtherInsuranceCard;
